// extracted by mini-css-extract-plugin
module.exports = {"container":"eventPage_container__kTLIA","sectionTitle":"eventPage_sectionTitle__3JJ3C"};